import Vue from 'vue'
import Router from 'vue-router'

import checkLogin from '/@/router/middleware/checkLogin'
import checkPluginAuth from '/@/router/middleware/checkPluginAuth'
import checkPlan from '/@/router/middleware/checkPlan'
import tagsControl from '/@/router/middleware/tagsControl'
import { routes } from './routes'

Vue.use(Router)

const router = new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes
})

// 路由守卫
router.beforeEach(checkLogin)
router.beforeEach(checkPluginAuth)
router.beforeEach(checkPlan)
router.beforeEach(tagsControl)

export default router
